export const PROJECT_CATEGORIES = [
  "Single Model",
  "Digital Marketing", 
  "AI Video",
  "Double Model",
  "Voice + Animation",
  "Web Development",
  "Graphics Designing",
  "Uncategorized"
] as const;

export type ProjectCategory = typeof PROJECT_CATEGORIES[number];